import { colorRange as l } from "./color-range.js";
function t(r) {
  return r.map(
    (e) => `${e[0]}em ${e[1]}em ${e[2]}em ${e[3]}em ${e[4]}`
  ).join(", ");
}
function m(r) {
  return r.map((e) => e.length === 5 ? `drop-shadow(${e[0]}em ${e[1]}em ${e[2]}em ${e[4]})` : `drop-shadow(${e[0]}em ${e[1]}em ${e[2]}em ${e[3]})`).join(" ");
}
function o(r) {
  return {
    box() {
      return {
        xs: t(r.xs),
        sm: t(r.sm),
        md: t(r.md),
        lg: t(r.lg),
        xl: t(r.xl)
      };
    },
    drop() {
      return {
        xs: m(r.xs),
        sm: m(r.sm),
        md: m(r.md),
        lg: m(r.lg),
        xl: m(r.xl)
      };
    }
  };
}
function c(r) {
  const e = {};
  for (const [n, i] of Object.entries(r))
    n === "black" || n === "white" || n === "overlay" || (e[n] = u(i));
  return e.black = r.white, e.white = r.black, e.overlay = r.overlay, e;
}
function u(r) {
  const e = {};
  for (let n = 0, i = l.length - 1; n < l.length; n++, i--)
    e[l[n]] = r[l[i]];
  return e;
}
export {
  c as invertColorPalette,
  o as shadows
};
